import { Routes, Route, Navigate } from "react-router-dom";
import {
  DashboardLayout,
  PageNotFound,
  ProtectedRoute,
  UnAuthorised,
} from "../../shared";

import {
  Profile,
  RolesAndPermissions,
  StateAndSuburb,
  Terminals,
  TaxGroupsAndTaxes,
  Customers,
  CustomerSegmentation,
  Stores,
  Category,
  AdminUsers,
  Discount,
  Products,
  Orders,
  Wastage,
  PriceLevels,
  Invitation,
  ManagerPassword,
  Favourites,
  Bundles,
  BirthdayCoupons,
  BirthdayCouponsV2,
  BFITDashboard,
  EndoftheDay,
  MenuBanners,
  Report,
  DepositSlip,
  ReviewsAndRatings,
  ClientAccounts,
  Loyalty,
  EmailSettings,
  CFD,
  Surcharges,
  COA,
  POSSettings,
  ProductSorting,
  Ubereats,
  DiscountOrders,
  FuturePrice,
  CouponReport,
  CartProduct,
  PushNotification,
  List,
  PLReport,
  Doordash,
  ProductConfigurations,
  QRCode,
  PaymentMediaReport,
  AgedDebtorsReportRoutes,
  PLDashboard,
  Tanda,
  SuperAdminSettings,
  ReportSettings,
  StripeConnect,
  PromosAndNotificationRoutes,
  StampCards,
  StoreReportsRoute,
  ProductSalesWastageReportRoute,
  PointPromotions,
  AppSettings,
  TenantConfig,
  FullTaxInvoiceRoutes,
  SalesVatReport,
} from "../../modules";
import { Franchisee } from "../../modules/Franchisee/Franchisee";
import { AvailabilityGroup } from "../../modules/AvailabilityGroup/AvailabilityGroup";
import { OptionalGroup } from "../../modules/OptionalGroup.js/OptionalGroup";
import { Refund } from "../../modules/Refund";
import { Coupons } from "../../modules/Coupons/Coupons";
import { Conditions } from "../../modules/Conditions/Conditions";
import { ProductRatings } from "../../modules/ProductRatings/ProductRatings";
import { GiftCard } from "../../modules/GiftCard/GiftCard";
import { Menulog } from "../../modules/Menulog/Menulog";
import { Configurations } from "../../modules/Configurations";
import { TopSelling } from "../../modules/TopSelling";
import { MenuTemplate } from "../../modules/MenuTemplate/MenuTemplate";
import { OnlineOrdering } from "../../modules/OnlineOrdering/OnlineOrdering";
import { Myob, Xero } from "../../modules/XeroAndMyObCopy";
import { ClientAccountsV2 } from "../../modules/ClientAccountsV2/ClientAccountsV2";
import { EmailLogRoutes } from "../../modules/EmailLog";

export function Dashboard() {
  return (
    <div id="app">
      <DashboardLayout>
        <div id="main-content">
          <Routes>
            <Route
              element={<ProtectedRoute allowedRoute={["dashboard-view"]} />}
            >
              <Route path="/" element={<BFITDashboard />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["report-view"]} />}>
              <Route path="/store-reports/*" element={<StoreReportsRoute />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["report-view"]} />}>
              <Route
                path="/product-sales-wastage-report/*"
                element={<ProductSalesWastageReportRoute />}
              />
            </Route>
            <Route
              path="/superset-dashboard"
              element={<Navigate to="/store-reports" replace />}
            />
            <Route element={<ProtectedRoute allowedRoute={["role-view"]} />}>
              <Route
                path="/roles-and-permissions/*"
                element={<RolesAndPermissions />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["user-view"]} />}>
              <Route path="/admin-users/*" element={<AdminUsers />} />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["state-view", "city-view"]} />
              }
            >
              <Route path="/state-and-suburb/*" element={<StateAndSuburb />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["franchisee-view"]} />}
            >
              <Route path="/franchisee/*" element={<Franchisee />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["tax-view"]} />}>
              <Route
                path="/tax-groups-and-taxes/*"
                element={<TaxGroupsAndTaxes />}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["category-view"]} />}
            >
              <Route path="/category/*" element={<Category />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["product-view"]} />}>
              <Route path="/products/*" element={<Products />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["terminal-view"]} />}
            >
              <Route path="/terminal/*" element={<Terminals />} />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["availability-group-view"]} />
              }
            >
              <Route
                path="/availabilityGroup/*"
                element={<AvailabilityGroup />}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["customer-view"]} />}
            >
              <Route path="/customers/*" element={<Customers />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["segment-view"]} />}>
              <Route
                path="/customer-segmentation/*"
                element={<CustomerSegmentation />}
              />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["optional-group-view"]} />
              }
            >
              <Route path="/optionalGroup/*" element={<OptionalGroup />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["store-view"]} />}>
              <Route path="/stores/*" element={<Stores />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["discount-view"]} />}
            >
              <Route path="/discount/*" element={<Discount />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["price-level-view"]} />}
            >
              <Route path="/price-levels/*" element={<PriceLevels />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["refund-view"]} />}>
              <Route path="/refund/*" element={<Refund />} />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["fti-view"]} feature="fti" />
              }
            >
              <Route
                path="/full-tax-invoice/*"
                element={<FullTaxInvoiceRoutes />}
              />
              <Route path="/sales-vat-report/*" element={<SalesVatReport />} />
            </Route>

            {/* Payment Media Report */}
            <Route
              element={<ProtectedRoute allowedRoute={["payment-media-view"]} />}
            >
              <Route
                element={<PaymentMediaReport />}
                path="/payment-media-report/*"
              />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["manager-password-view"]} />
              }
            >
              <Route path="/manager-password/*" element={<ManagerPassword />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["favourite-view"]} />}
            >
              <Route exact element={<Favourites />} path={"/favourites/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["wastage-view"]} />}>
              <Route path="/wastage/*" element={<Wastage />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["condition-view"]} />}
            >
              <Route exact element={<Conditions />} path={"/coupon-rules/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["coupon-view"]} />}>
              <Route exact element={<Coupons />} path={"/coupons/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["coupon-view"]} />}>
              <Route
                exact
                element={<CouponReport />}
                path={"/coupon-report/*"}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["order-view"]} />}>
              <Route exact element={<Orders />} path={"/orders/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["order-view"]} />}>
              <Route
                exact
                element={<DiscountOrders />}
                path={"/discount-orders/*"}
              />
            </Route>
            <Route exact element={<Bundles />} path={"/bundle/*"} />
            <Route element={<ProtectedRoute allowedRoute={["coupon-view"]} />}>
              <Route path="/birthday-coupons/*" element={<BirthdayCoupons />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["coupon-view"]} />}>
              <Route
                path="/birthday-coupons-v2/*"
                element={<BirthdayCouponsV2 />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["banner-view"]} />}>
              <Route exact element={<MenuBanners />} path={"/menu-banner/*"} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["end-of-day-view"]} />}
            >
              <Route path="/end-of-day/*" element={<EndoftheDay />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["loyalty-cards-view"]} />}
            >
              <Route path="/loyalty-cards/*" element={<Loyalty />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["report-view"]} />}>
              <Route element={<Report />} path={"/reports/*"} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["deposit-slip-view"]} />}
            >
              <Route path="/deposit-slip/*" element={<DepositSlip />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["gift-cards-view"]} />}
            >
              <Route path="/gift-card/*" element={<GiftCard />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["integration-view"]} />}
            >
              <Route path="/menulog/*" element={<Menulog />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["integration-view"]} />}
            >
              <Route path="/tanda/*" element={<Tanda />} />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["client-account-view"]} />
              }
            >
              <Route path="/client-account/*" element={<ClientAccounts />} />
              <Route
                path="/client-account-v2/*"
                element={<ClientAccountsV2 />}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["email-setting-view"]} />}
            >
              <Route
                exact
                element={<EmailSettings />}
                path={"/email-settings/*"}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["email-setting-view"]} />}
            >
              <Route
                exact
                element={<SuperAdminSettings />}
                path={"/settings/*"}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["settings-view"]} />}
            >
              <Route exact element={<AppSettings />} path={"/app-settings/*"} />
              <Route
                exact
                element={<TenantConfig />}
                path={"/tenant-config/*"}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["cfd-view"]} />}>
              <Route exact element={<CFD />} path={"/cfd/*"} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["surcharge-view"]} />}
            >
              <Route exact element={<Surcharges />} path={"/surcharges/*"} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["pos-setting-view"]} />}
            >
              <Route exact element={<POSSettings />} path={"/pos-settings/*"} />
              <Route
                element={<ProtectedRoute allowedRoute={["integration-view"]} />}
              >
                <Route exact element={<Ubereats />} path={"/ubereats/*"} />
              </Route>
              <Route
                element={<ProtectedRoute allowedRoute={["integration-view"]} />}
              >
                <Route exact element={<Doordash />} path={"/doordash/*"} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["coa-view"]} />}>
              <Route exact element={<COA />} path={"/coa/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["coa-view"]} />}>
              <Route
                exact
                element={<Configurations />}
                path={"/configurations/*"}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["dashboard-view"]} />}
            >
              <Route exact element={<ProductSorting />} path={"/keypad/*"} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["future-price-view"]} />}
            >
              <Route exact element={<FuturePrice />} path={"/future-price/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["product-view"]} />}>
              <Route exact element={<TopSelling />} path={"/top-selling/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["product-view"]} />}>
              <Route exact element={<CartProduct />} path={"/cart-product/*"} />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["xero-myob-report-view"]} />
              }
            >
              {/* <Route exact element={<XeroAndMyOb />} path={"/xero-myob/*"} /> */}
              <Route exact element={<Xero />} path={"/xero/*"} />
              <Route exact element={<Myob />} path={"/myob/*"} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["product-view"]} />}>
              <Route
                exact
                element={<PushNotification />}
                path={"/push-notification/*"}
              />
            </Route>

            {/* PL&BS */}
            <Route
              element={<ProtectedRoute allowedRoute={["pl-bs-account-view"]} />}
            >
              <Route path="/pl-dashboard/*" element={<PLDashboard />} />
              <Route path={"/list/*"} element={<List />} />
              <Route path={"/pl-report/*"} element={<PLReport />} />
            </Route>

            <Route element={<ProtectedRoute allowedRoute={["menu-view"]} />}>
              <Route path="/menu-template/*" element={<MenuTemplate />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["integration-view"]} />}
            >
              <Route path="/online-ordering/*" element={<OnlineOrdering />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["review-rating-view"]} />}
            >
              <Route
                exact
                element={<ProductConfigurations />}
                path={"/configurations-review/*"}
              />
              <Route
                exact
                element={<ProductRatings />}
                path={"/products-ratings/*"}
              />
              <Route
                exact
                element={<ReviewsAndRatings />}
                path={"/reviews-and-ratings/*"}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["qrcode-view"]} />}>
              <Route path="/qr-code/*" element={<QRCode />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoute={["product-view"]} />}>
              <Route path="/report-settings/*" element={<ReportSettings />} />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoute={["integration-view"]} />}
            >
              <Route path="/stripe-connect/*" element={<StripeConnect />} />
            </Route>
            <Route
              element={
                <ProtectedRoute
                  allowedRoute={["client-account-aged-debtors-view"]}
                />
              }
            >
              <Route
                path="/aged-debtors-report/*"
                element={<AgedDebtorsReportRoutes />}
              />
            </Route>
            {/* Email log */}
            <Route
              element={<ProtectedRoute allowedRoute={["email-log-view"]} />}
            >
              <Route path="/email-log/*" element={<EmailLogRoutes />} />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["promo-notification-view"]} />
              }
            >
              <Route
                exact
                element={<PromosAndNotificationRoutes />}
                path={"/promos-and-notifications/*"}
              />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["promo-notification-view"]} />
              }
            >
              <Route exact element={<StampCards />} path={"/stamp-cards/*"} />
            </Route>
            <Route
              element={
                <ProtectedRoute allowedRoute={["points-promotion-view"]} />
              }
            >
              <Route
                exact
                element={<PointPromotions />}
                path={"/point-promotions/*"}
              />
            </Route>

            <Route exact element={<Invitation />} path={"/invitation/*"} />
            <Route exact element={<Profile />} path={"/profile/*"} />
            <Route exact element={<UnAuthorised />} path={"/unauthorized"} />
            <Route exact element={<PageNotFound />} path={"/404"} />
            <Route exact element={<PageNotFound />} path={"*"} />
          </Routes>
        </div>
      </DashboardLayout>
    </div>
  );
}
